export const SOCIALS = {
  facebook: 'https://www.facebook.com/cryptoglobalunited',
  instagram: 'https://www.instagram.com/crypto.global.united/',
  twitter: 'https://twitter.com/CryptoGlobalUtd',
  discord: 'https://discord.com/invite/cgu',
  youtube: 'https://www.youtube.com/@cryptoglobalunited'
}
